import { render, staticRenderFns } from "./MdmLoader.vue?vue&type=template&id=0499bd5c&scoped=true&name=mdm-loader&"
import script from "./MdmLoader.vue?vue&type=script&lang=js&"
export * from "./MdmLoader.vue?vue&type=script&lang=js&"
import style0 from "./MdmLoader.vue?vue&type=style&index=0&id=0499bd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499bd5c",
  null
  
)

export default component.exports